import { render, staticRenderFns } from "./LApiViewer.vue?vue&type=template&id=078d48ae&scoped=true"
import script from "./LApiViewer.vue?vue&type=script&lang=js"
export * from "./LApiViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078d48ae",
  null
  
)

export default component.exports